var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalAssets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11695",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11696",
    d: "M4 8.6V21h16V8.6",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11697",
    d: "M2 10l10-7 10 7",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11698",
    d: "M15 21v-6a2 2 0 00-2-2h-2a2 2 0 00-2 2v6",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgTotalAssets;


//////////////////
// WEBPACK FOOTER
// ./src/icons/totalAssets.svg
// module id = 900
// module chunks = 101